import React, { useState, useEffect } from "react";
import * as reportApi from "../../api/requests/report";
import { Link } from "react-router-dom";
import {
  IonCard,
  IonCardContent,
  IonBadge,
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
} from "@ionic/react";
import { Helmet } from "react-helmet-async";
import "./FlaggedUsers.css";
import { useSelector } from "react-redux";
import Avatar from "../../components/avatar/Avatar";

const FlaggedUsers = () => {
  const [flaggedUsers, setFlaggedUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFlaggedUsers();
  }, []);

  const fetchFlaggedUsers = async () => {
    setLoading(true);
    try {
      const response = await reportApi.getAllFlaggedUsers();
      // Adjust based on your API response structure
      if (response?.data) {
        setFlaggedUsers(response.data);
      }
    } catch (error) {
      console.error("Error fetching flagged users:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };
  const currentUser = useSelector((state) => state.currentProfile.data);
  const isAdmin = currentUser?.isAdmin || false;

  if (!isAdmin) {
    return (
      <>
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <div>
          <h2>Access Denied</h2>
          <p>You do not have permission to view this page.</p>
        </div>
      </>
    );
  }
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Flagged Users</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <Helmet>
          <title>Flagged Users | Admin</title>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>

        <div className="flagged-header">
          <h2>Flagged for Suspicious Activity</h2>
          <p>Users who messaged 3+ strangers in the last 24 hours.</p>
        </div>

        {loading ? (
          <div className="reports-loading">Analyzing message logs...</div>
        ) : flaggedUsers.length === 0 ? (
          <div className="reports-empty">No suspicious activity detected.</div>
        ) : (
          <div className="flagged-list">
            {Array.isArray(flaggedUsers) ? (
              flaggedUsers.map((user) => (
                <IonCard key={user._id} className="flagged-card">
                  <IonCardContent>
                    <div className="flagged-user-row">
                      <div className="user-info-main">
                        <Avatar
                          username={user.username}
                          avatar={user.avatar}
                          province={user.province}
                          className="report-avatar"
                        />
                        <div className="user-details">
                          <Link
                            to={`/profile/${user.username}`}
                            className="user-link"
                          >
                            {user.fname} {user.lname} (@{user.username})
                          </Link>
                          <span className="joined-date">
                            Joined: {formatDate(user.createdAt)}
                          </span>
                        </div>
                      </div>

                      <div className="flag-reason-tag">
                        <IonBadge color="danger">Potential Spammer</IonBadge>
                      </div>
                    </div>

                    <div className="flagged-stats">
                      <div className="stat-item">
                        <strong>Following:</strong>{" "}
                        {user.following?.length || 0}
                      </div>
                      <div className="stat-item">
                        <strong>Followers:</strong>{" "}
                        {user.followers?.length || 0}
                      </div>
                      <div className="stat-item">
                        <strong>Blocked By:</strong> {user.blockedByCount || 0}
                      </div>
                      {/* --- ADD THESE NEW STATS --- */}
                      <div className="stat-item highlight-red">
                        <strong>Strangers (24h):</strong>{" "}
                        {user.uniqueStrangerChatsCountLastDay || 0}
                      </div>
                      <div className="stat-item">
                        <strong>Total Sent (24h):</strong>{" "}
                        {user.totalMessagesSentLastDay || 0}
                      </div>
                      <div className="stat-item">
                        <strong>Lifetime Sent:</strong>{" "}
                        {user.totalMessagesAllTime || 0}
                      </div>
                    </div>

                    {/* --- NEW MESSAGE LOGS SECTION --- */}
                    <div className="activity-logs">
                      <h4 className="logs-header">
                        Recent Message Logs (Last 6)
                      </h4>
                      {user.lastMessages && user.lastMessages.length > 0 ? (
                        <div className="logs-list">
                          {user.lastMessages.map((msg) => (
                            <div key={msg._id} className="log-entry">
                              <div className="log-meta">
                                <span className="log-direction">
                                  To: <strong>@{msg.to}</strong>
                                </span>
                                <span className="log-time">
                                  {new Date(msg.createdAt).toLocaleTimeString()}
                                </span>
                              </div>
                              <p className="log-text">
                                {msg.text || "No text content"}
                              </p>
                              {msg.media && (
                                <div className="log-media-tag">
                                  <small>
                                    📎 Media:{" "}
                                    <img
                                      src={msg.media.url}
                                      alt={msg.username}
                                    />
                                  </small>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p className="no-logs">No message data available.</p>
                      )}
                    </div>
                  </IonCardContent>
                </IonCard>
              ))
            ) : (
              <div
                className="error-container"
                style={{ padding: "20px", textAlign: "center" }}
              >
                <p>⚠️ You are not authorized to view this data.</p>
              </div>
            )}
          </div>
        )}
      </IonContent>
    </IonPage>
  );
};

export default FlaggedUsers;
